<main class="auth-shell min-h-screen px-4 py-10">
  <section class="mx-auto grid min-h-[calc(100vh-5rem)] w-full max-w-5xl items-center gap-8 lg:grid-cols-[1fr_420px]">
    <div class="hidden lg:block">
      <div class="brand-mark mb-6">
        <span>{{ 'common.brand' | translate }}</span>
      </div>
      <p class="mb-3 text-sm font-semibold uppercase tracking-[0.22em] text-cyan-700">Single Sign-On</p>
      <h1 class="m-0 max-w-xl text-4xl font-semibold leading-tight text-slate-950">
        {{ 'login.heroTitle' | translate }}
      </h1>
      <p class="mt-5 max-w-lg text-base leading-7 text-slate-600">
        Тестовый вход.
      </p>
    </div>

    <nz-card class="auth-card w-full" nzTitle="Авторизация (тест)">
      <form
        class="mt-6"
        [formGroup]="form"
        (ngSubmit)="tryAuthenticate()"
      >
        <nz-form-item>
          <nz-form-label>ИИН</nz-form-label>
          <nz-form-control nzErrorTip="ИИН должен быть длиной 12 символов">
            <nz-input-wrapper>
              <nz-icon nzInputPrefix nzType="user"/>
              <input
                nz-input
                formControlName="login"
                maxlength="12"
              >
            </nz-input-wrapper>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Пароль</nz-form-label>
          <nz-form-control nzErrorTip="Пароль обязателен">
            <nz-input-password [(nzVisible)]="visible">
              <nz-icon nzInputPrefix nzType="lock"/>
              <input
                nz-input
                formControlName="password"
              >
            </nz-input-password>
          </nz-form-control>
        </nz-form-item>

        <div class="mt-6 flex flex-col gap-3">
          <button
            class="w-full"
            nz-button
            nzType="primary"
            type="submit"
            [nzLoading]="isAuthenticating"
            [disabled]="form.invalid"
          >
            Войти
          </button>
        </div>
      </form>
    </nz-card>
  </section>
</main>
